<template>
  <div
    class="active-filters-wrapper"
    :class="{'-filters-active': resetVisible}"
  >
    <div
      v-if="active"
      class="tags"
    >
      <ul>
        <li
          v-for="(filter) in categories"
          :key="filter.label"
        >
          <active-filter-tag
            is-category
            :filter="filter"
          />
        </li>
      </ul>
      <ul>
        <li
          v-for="(filter) in valueFilters"
          :key="filter.label"
        >
          <active-filter-tag :filter="filter" />
        </li>
      </ul>
    </div>
    <button
      class="reset"
      v-show="resetVisible"
      @click="resetFilters"
    >
      {{ $t('components.vehicles_filters.all_vehicles') }}
    </button>
  </div>
</template>
<script>
import ActiveFilterTag from './ActiveFilterTag';

export default {
  props: {
    active: {
      type: Object,
      required: true,
    },
  },
  components: {
    ActiveFilterTag,
  },
  computed: {
    categories() {
      return this.active.categories;
    },
    valueFilters() {
      return this.active.filters;
    },
    resetVisible() {
      return this.categories.length || this.valueFilters.length;
    },
  },
  methods: {
    resetFilters() {
      [...this.categories].forEach((filter) => {
        this.$store.commit('vehicles/filters/REMOVE_ACTIVE_FILTER', {
          type: 'category',
          filter,
        });
      });
      [...this.valueFilters].forEach((filter) => {
        this.$store.commit('vehicles/filters/REMOVE_ACTIVE_FILTER', {
          type: 'filter',
          filter,
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";
@import '../../../../../_src/sass/config/responsive';

.active-filters-wrapper {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  max-height: 0;
  min-height: 0;
  padding: 0;
  transition: min-height 200ms ease-out, max-height 200ms ease-out;
  width: 100%;

  &.-filters-active {
    max-height: 100px;
    min-height: 100px;
    padding: 15px;

    @include teq-breakpoint($medium) {
      padding: 15px 0;
    }
  }
}

ul {
  display: flex;
  min-height: 30px;

  & + & {
    margin: 10px 0 0;
  }
}

li {
  & + & {
    margin: 0 0 0 5px;
  }
}

.reset {
  align-items: center;
  background: $c-silver;
  border: none;
  cursor: pointer;
  display: flex;
  font-family: $f-graphie-book;
  justify-content: center;
  padding: 10px 10px;
}
</style>
